// src/data/reservationData.js
import { Dices, Sword, Cake, LoaderPinwheel } from 'lucide-react';

export const RESERVATION_TYPES = [
  {
    id: 'boardgame',
    title: 'Mesa de Board Game',
    subtitle: 'Passaporte R$29 por pessoa',
    priceBadge: 'R$29 por Pessoa',
    description: 'A experiência clássica Deli da Persy. Reúna sua trupe para uma tarde de jogos, petiscos e muitas risadas.',
    icon: Dices,
    color: 'teal',
    benefits: [
      'Passaporte promocional: de R$36 por R$29',
      'Acesso ilimitado ao acervo de jogos',
      'Mesa garantida para o seu grupo',
      'Tempo de jogo livre a noite toda'
    ]
  },
  {
    id: 'rpg',
    title: 'Sessão Épica de RPG',
    subtitle: 'Sessão Guiada (4 horas)',
    priceBadge: 'Mesa Fechada R$222',
    description: 'Mergulhe em outro mundo. Nós fornecemos o mestre, os cenários e a magia. Você só precisa trazer a coragem.',
    icon: Sword,
    color: 'wine',
    benefits: [
      'Dungeon Master profissional Deli',
      'Escolha seu sistema favorito',
      'Ajudamos na criação da ficha',
      'Uso de miniaturas e terrenos 3D'
    ]
  },
  {
    id: 'deliparty',
    title: 'Deli Party',
    subtitle: 'Pacote para até 8 pessoas',
    priceBadge: 'A partir de 4 pessoas',
    description: 'Celebre seu dia especial rolando dados. Um ambiente decorado e comidinhas prontas para sua festa.',
    icon: Cake,
    color: 'wine',
    benefits: [
      '1 bolo ou torta gelada',
      '2 rodadas de suco ou refri',
      '1 rodada de sanduíches a sua escolha',
      'Atendimento exclusivo para a mesa',
      'Decoração temática simples'
    ]
  },
  {
    id: 'kids',
    title: 'Aventura Kids',
    subtitle: 'Pacote para até 8 crianças',
    priceBadge: 'R$69 por criança',
    description: 'Diversão garantida para os pequenos jogadores com monitoria dedicada e lanchinhos deliciosos.',
    icon: LoaderPinwheel,
    color: 'teal',
    benefits: [
      'Monitor exclusivo para explicar jogos',
      'Porção de batata e nuggets por criança',
      '1 rodada de suco ou refrigerante',
      'Seleção de jogos infantis adequados'
    ]
  }
];